export default "__VITE_ASSET__s2TtyeGr__"